import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserRelatedServiceOfferRepository } from './domain'

import { UserRelatedServiceOffer } from '../../contracts/service-offer'
import { AxiosErrorHandler } from '../../foundation'

export class UserApiRelatedServiceOffer implements UserRelatedServiceOfferRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (serviceOfferId: number): Promise<UserRelatedServiceOffer[]> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      method: 'post',
      url: '/service-offer/query/user/related-list/process',
      data: { id: serviceOfferId },
    }

    try {
      const { data } = await this.axios.request<UserRelatedServiceOffer[]>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
